function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Card, Pill } from "../../components/analytics-kit";
import { CONNECT_GROUPS, connectionStatus } from "../../components/provider-connections";
import { adBillingMode } from "../../functions/tenant-features";
import { dataSvc as svc, safe, isAdmin, Btn, Notice } from "./shell";

/*
 * Provider connections on the kit: the one connections registry (content connectors + social rail),
 * rendered as one table with a group row per family and the connect form as an expanded row.
 * Rails and behaviour are those of components/provider-connections.jsx (which the legacy page keeps).
 */
const PRETTY = {
  pinterest: "Pinterest",
  linkedin: "LinkedIn",
  youtube: "YouTube",
  tiktok: "TikTok"
};
const TONE = {
  ok: "success",
  warn: "warning",
  off: "neutral"
};
const CUSTOM0 = {
  url: "",
  method: "POST",
  auth_type: "bearer",
  header_name: "X-Api-Key",
  sign: false,
  id_path: "id",
  url_path: "url",
  template: ""
};
export default class Connections extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      connectors: null,
      social: null,
      connecting: null,
      token: "",
      busy: false,
      note: null,
      confirmDisconnect: null,
      custom: {
        ...CUSTOM0
      },
      testReply: null
    });
    _defineProperty(this, "connect", async item => {
      const token = (this.state.token || "").trim();
      if (!token && !item.custom) {
        this.setState({
          note: "Paste the provider API key first."
        });
        return;
      }
      if (item.custom && !/^https:\/\//i.test((this.state.custom.url || "").trim())) {
        this.setState({
          note: "Enter the https endpoint URL first."
        });
        return;
      }
      this.setState({
        busy: true,
        note: null,
        testReply: null
      });
      try {
        const c = this.state.custom;
        const config = item.custom ? {
          url: c.url.trim(),
          method: c.method,
          auth_type: token ? c.auth_type : "none",
          header_name: c.header_name,
          sign: !!c.sign,
          id_path: c.id_path || "id",
          url_path: c.url_path || "url",
          template: (c.template || "").trim() || undefined
        } : undefined;
        await svc("/content/connectors/connect").postAsync({
          provider: item.key,
          token: token || (item.custom ? "none" : token),
          type: item.type || "email",
          capabilities: item.custom ? "write" : undefined,
          config: config ? JSON.stringify(config) : undefined
        });
        if (!this._alive) return;
        this.setState({
          busy: false,
          connecting: null,
          token: "",
          note: item.custom ? "Custom API connected: use Send test to check your endpoint, then Publish → Custom API on any variant." : `${item.label} connected: the history import runs on the next content sync (within a day); imported campaigns land in the Content Library.`
        });
        this.load();
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          note: e.message && e.message.length < 160 ? e.message : "Connect failed: check the key and try again."
        });
      }
    });
    _defineProperty(this, "testCustom", async () => {
      this.setState({
        busy: true,
        testReply: null
      });
      try {
        const r = await svc("/content/connectors/test").postAsync({
          provider: "custom_api"
        });
        this.setState({
          busy: false,
          testReply: r
        });
      } catch (e) {
        this.setState({
          busy: false,
          testReply: {
            ok: false,
            status: 0,
            reply: e && e.message || "Request failed"
          }
        });
      }
    });
    _defineProperty(this, "setCustom", patch => this.setState({
      custom: {
        ...this.state.custom,
        ...patch
      }
    }));
    _defineProperty(this, "startMetaOAuth", async rerequest => {
      this.setState({
        busy: true,
        note: null
      });
      try {
        const redirectUri = window.location.origin + "/OAuth/Meta";
        const r = await svc("/social/oauth/meta/start?redirectUri=" + encodeURIComponent(redirectUri) + (rerequest ? "&rerequest=true" : "")).getAsync();
        if (r && r.url) {
          window.location.href = r.url;
          return;
        }
        this.setState({
          busy: false,
          note: "Meta connect is not configured yet: email support@plunk.io and we will link it."
        });
      } catch (e) {
        this.setState({
          busy: false,
          note: e && e.message && e.message.length < 160 ? e.message : "Could not start the Meta connection."
        });
      }
    });
    _defineProperty(this, "startOAuth", async provider => {
      this.setState({
        busy: true,
        note: null
      });
      try {
        const redirectUri = window.location.origin + "/OAuth/" + provider;
        const r = await svc(`/social/oauth/${provider}/start?redirectUri=` + encodeURIComponent(redirectUri)).getAsync();
        if (r && r.url) {
          window.location.href = r.url;
          return;
        }
        this.setState({
          busy: false,
          note: `${PRETTY[provider] || provider} connect is not configured yet: email support@plunk.io and we will link it.`
        });
      } catch (e) {
        this.setState({
          busy: false,
          note: e && e.message && e.message.length < 160 ? e.message : `Could not start the ${PRETTY[provider] || provider} connection.`
        });
      }
    });
    _defineProperty(this, "disconnect", async row => {
      this.setState({
        busy: true,
        note: null
      });
      try {
        await svc(`/content/connectors/${String(row.id)}`).deleteAsync();
        if (!this._alive) return;
        this.setState({
          busy: false,
          confirmDisconnect: null,
          note: "Disconnected: imports stop; already-imported content stays in the Library."
        });
        this.load();
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          note: "Disconnect failed: try again."
        });
      }
    });
    _defineProperty(this, "disconnectSocial", async (item, rows) => {
      this.setState({
        busy: true,
        note: null
      });
      try {
        for (const a of rows || []) await svc(`/social/accounts/${String(a.id)}`).deleteAsync();
        if (!this._alive) return;
        this.setState({
          busy: false,
          confirmDisconnect: null,
          note: `Disconnected ${PRETTY[item.key] || item.label}: Plunk no longer has access, and what you already published stays where it is.`
        });
        this.load();
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          note: "Disconnect failed: try again."
        });
      }
    });
  }
  componentDidMount() {
    this._alive = true;
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  async load() {
    const [conn, social] = await Promise.all([safe(svc("/content/connectors").getAsync(), {
      items: []
    }), safe(svc("/social/accounts").getAsync(), {
      items: []
    })]);
    if (this._alive) this.setState({
      connectors: conn.items || [],
      social: social.items || []
    });
    if (this.props.onLoaded) this.props.onLoaded({
      connectors: conn.items || [],
      social: social.items || []
    });
  }
  renderAction(item, st, admin, selfService) {
    const {
      busy,
      connecting,
      confirmDisconnect
    } = this.state;
    const open = connecting === item.key;
    if (item.kind === "link") return /*#__PURE__*/React.createElement("a", {
      className: "wa-rowlink",
      onClick: () => this.props.history && this.props.history.push(item.route)
    }, "Open settings");
    if (item.kind === "info") return /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "Shown in the cards above");
    if (item.kind === "social") {
      // Disconnect (2026-10-08): every live account behind the row; the API revokes with the network and deletes the token.
      const canDisconnect = admin && st.cls !== "off" && (st.rows || []).length > 0;
      if (canDisconnect && confirmDisconnect === item.key) return /*#__PURE__*/React.createElement("span", {
        className: "acts"
      }, /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, "Plunk loses access; published posts stay."), /*#__PURE__*/React.createElement("a", {
        className: "wa-rowlink danger",
        onClick: () => !busy && this.disconnectSocial(item, st.rows)
      }, "Confirm"), /*#__PURE__*/React.createElement("a", {
        className: "wa-rowlink muted",
        onClick: () => this.setState({
          confirmDisconnect: null
        })
      }, "Keep"));
      let connect = null;
      if (item.key === "meta" && admin) connect = /*#__PURE__*/React.createElement("a", {
        className: "wa-rowlink",
        onClick: () => !busy && this.startMetaOAuth(st.cls !== "off")
      }, st.cls === "off" ? "Connect with Facebook" : "Reconnect with Facebook");else if (item.oauth && admin) connect = /*#__PURE__*/React.createElement("a", {
        className: "wa-rowlink",
        onClick: () => !busy && this.startOAuth(item.key)
      }, st.cls === "off" ? `Connect with ${PRETTY[item.key]}` : `Reconnect with ${PRETTY[item.key]}`);else if (item.key === "meta" || item.oauth) connect = st.cls === "off" ? /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, "Managed by workspace owners") : null;else connect = st.cls === "off" ? /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, selfService ? "Linked by support: email support@plunk.io with your Business Profile name" : "Connected by the Plunk team: contact your rep") : null;
      if (!canDisconnect) return connect;
      return /*#__PURE__*/React.createElement("span", {
        className: "acts"
      }, connect, /*#__PURE__*/React.createElement("a", {
        className: "wa-rowlink muted",
        onClick: () => this.setState({
          confirmDisconnect: item.key,
          note: null
        })
      }, "Disconnect"));
    }
    if (!admin) return null;
    if (st.cls !== "ok") return /*#__PURE__*/React.createElement("a", {
      className: "wa-rowlink",
      onClick: () => this.setState({
        connecting: open ? null : item.key,
        token: "",
        note: null
      })
    }, open ? "Cancel" : st.cls === "warn" ? "Reconnect" : "Connect");
    if (confirmDisconnect === item.key) return /*#__PURE__*/React.createElement("span", {
      className: "acts"
    }, /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "Imports stop; imported content stays."), /*#__PURE__*/React.createElement("a", {
      className: "wa-rowlink danger",
      onClick: () => !busy && this.disconnect(st.row)
    }, "Confirm"), /*#__PURE__*/React.createElement("a", {
      className: "wa-rowlink muted",
      onClick: () => this.setState({
        confirmDisconnect: null
      })
    }, "Keep"));
    return /*#__PURE__*/React.createElement("span", {
      className: "acts"
    }, item.custom ? /*#__PURE__*/React.createElement("a", {
      className: "wa-rowlink",
      onClick: () => !busy && this.testCustom()
    }, busy ? "Sending…" : "Send test") : null, /*#__PURE__*/React.createElement("a", {
      className: "wa-rowlink muted",
      onClick: () => this.setState({
        confirmDisconnect: item.key,
        note: null
      })
    }, "Disconnect"));
  }
  renderForm(item) {
    const {
      token,
      busy,
      custom: c
    } = this.state;
    if (item.custom) {
      return /*#__PURE__*/React.createElement("div", {
        className: "custom"
      }, /*#__PURE__*/React.createElement("label", {
        className: "wide"
      }, "Endpoint URL", /*#__PURE__*/React.createElement("input", {
        value: c.url,
        placeholder: "https://your-site.com/api/plunk-publish",
        onChange: e => this.setCustom({
          url: e.target.value
        })
      })), /*#__PURE__*/React.createElement("label", null, "Method", /*#__PURE__*/React.createElement("select", {
        value: c.method,
        onChange: e => this.setCustom({
          method: e.target.value
        })
      }, /*#__PURE__*/React.createElement("option", null, "POST"), /*#__PURE__*/React.createElement("option", null, "PUT"))), /*#__PURE__*/React.createElement("label", null, "Auth", /*#__PURE__*/React.createElement("select", {
        value: c.auth_type,
        onChange: e => this.setCustom({
          auth_type: e.target.value
        })
      }, /*#__PURE__*/React.createElement("option", {
        value: "bearer"
      }, "Bearer token"), /*#__PURE__*/React.createElement("option", {
        value: "header"
      }, "Custom header"), /*#__PURE__*/React.createElement("option", {
        value: "basic"
      }, "Basic (user:password)"), /*#__PURE__*/React.createElement("option", {
        value: "none"
      }, "None"))), c.auth_type === "header" && /*#__PURE__*/React.createElement("label", null, "Header name", /*#__PURE__*/React.createElement("input", {
        value: c.header_name,
        onChange: e => this.setCustom({
          header_name: e.target.value
        })
      })), c.auth_type !== "none" && /*#__PURE__*/React.createElement("label", null, "Secret", /*#__PURE__*/React.createElement("input", {
        type: "password",
        value: token,
        placeholder: c.auth_type === "basic" ? "user:password" : "token",
        onChange: e => this.setState({
          token: e.target.value
        }),
        style: {
          fontFamily: "monospace"
        }
      })), /*#__PURE__*/React.createElement("label", null, "Reply id path", /*#__PURE__*/React.createElement("input", {
        value: c.id_path,
        placeholder: "id",
        onChange: e => this.setCustom({
          id_path: e.target.value
        })
      })), /*#__PURE__*/React.createElement("label", null, "Reply URL path", /*#__PURE__*/React.createElement("input", {
        value: c.url_path,
        placeholder: "url",
        onChange: e => this.setCustom({
          url_path: e.target.value
        })
      })), /*#__PURE__*/React.createElement("label", {
        className: "row"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: !!c.sign,
        onChange: e => this.setCustom({
          sign: e.target.checked
        })
      }), " Sign payloads (X-Plunk-Signature, HMAC-SHA256 with the secret)"), /*#__PURE__*/React.createElement("label", {
        className: "wide"
      }, "Payload template ", /*#__PURE__*/React.createElement("span", {
        className: "help"
      }, "optional JSON with ", "{{title}} {{body}} {{html}} {{excerpt}} {{channel}} {{kind}} {{images}} {{image}} {{videoUrl}} {{utm}} {{tags}} {{containerId}} {{variantId}} {{storyId}} {{publishedAt}}", "; blank sends the default payload with all of them"), /*#__PURE__*/React.createElement("textarea", {
        value: c.template,
        rows: 3,
        placeholder: "{\"title\": {{title}}, \"content\": {{html}}, \"status\": \"draft\"}",
        onChange: e => this.setCustom({
          template: e.target.value
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: "wide"
      }, /*#__PURE__*/React.createElement(Btn, {
        primary: true,
        disabled: busy,
        onClick: () => this.connect(item)
      }, busy ? "Connecting…" : "Save connection")));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "tokenrow"
    }, /*#__PURE__*/React.createElement("input", {
      type: "password",
      value: token,
      placeholder: `${item.label} API key`,
      onChange: e => this.setState({
        token: e.target.value
      })
    }), /*#__PURE__*/React.createElement(Btn, {
      primary: true,
      disabled: busy,
      onClick: () => this.connect(item)
    }, busy ? "Connecting…" : "Connect"), /*#__PURE__*/React.createElement("span", {
      className: "dim",
      style: {
        fontSize: 12
      }
    }, "The key is stored encrypted and never shown again."));
  }
  render() {
    let selfService = false;
    try {
      selfService = adBillingMode() !== "managed";
    } catch (e) {
      selfService = false;
    }
    const {
      connectors,
      social,
      connecting,
      note,
      testReply
    } = this.state;
    const admin = isAdmin();
    if (connectors === null) return null;
    const attention = CONNECT_GROUPS.flatMap(g => g.items).map(it => ({
      it,
      st: connectionStatus(it, connectors, social)
    })).filter(x => x.st.cls === "warn");
    return /*#__PURE__*/React.createElement(Card, {
      title: "Provider connections",
      hint: "every account Plunk reads from or publishes to",
      span: 12,
      cls: "cx-conn"
    }, /*#__PURE__*/React.createElement("p", {
      className: "lead"
    }, admin ? "Connecting takes the provider API key or a sign-in with the provider; each row says how. support@plunk.io can help." : "Connections are managed by workspace owners."), attention.length > 0 && /*#__PURE__*/React.createElement(Notice, {
      tone: "warning"
    }, /*#__PURE__*/React.createElement("span", {
      className: "grow"
    }, /*#__PURE__*/React.createElement("b", null, attention.length, " connection", attention.length > 1 ? "s" : "", " need", attention.length > 1 ? "" : "s", " attention:"), " ", attention.map(x => x.it.label).join(", "), admin ? ". Reconnect below." : ". A workspace owner can reconnect.")), note && /*#__PURE__*/React.createElement(Notice, {
      onClose: () => this.setState({
        note: null
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "grow"
    }, note)), testReply && /*#__PURE__*/React.createElement(Notice, {
      tone: testReply.ok ? "info" : "danger",
      onClose: () => this.setState({
        testReply: null
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "grow"
    }, testReply.ok ? `Test delivered · HTTP ${testReply.status}` : `Test failed · HTTP ${testReply.status}`, " ", String(testReply.reply || "").slice(0, 160))), /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Provider"), /*#__PURE__*/React.createElement("th", {
      style: {
        width: 150
      }
    }, "Status"), /*#__PURE__*/React.createElement("th", {
      style: {
        width: 120
      }
    }, "Last sync"), /*#__PURE__*/React.createElement("th", {
      style: {
        textAlign: "right"
      }
    }, "Action"))), /*#__PURE__*/React.createElement("tbody", null, CONNECT_GROUPS.map(group => [/*#__PURE__*/React.createElement("tr", {
      className: "group",
      key: "g-" + group.name
    }, /*#__PURE__*/React.createElement("td", {
      colSpan: 4
    }, group.name)), ...group.items.map(item => {
      const st = connectionStatus(item, connectors, social);
      const open = connecting === item.key;
      const rows = [/*#__PURE__*/React.createElement("tr", {
        key: item.key
      }, /*#__PURE__*/React.createElement("td", {
        className: "prov wrap"
      }, /*#__PURE__*/React.createElement("b", null, item.label), /*#__PURE__*/React.createElement("span", {
        className: "sub"
      }, item.hint), st.cls === "warn" && st.row && st.row.statusDetail ? /*#__PURE__*/React.createElement("span", {
        className: "sub",
        style: {
          color: "var(--plk-warning-text)"
        }
      }, st.row.statusDetail) : null), /*#__PURE__*/React.createElement("td", null, item.kind === "link" || item.kind === "info" ? /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, "\xB7") : /*#__PURE__*/React.createElement(Pill, {
        tone: TONE[st.cls] || "neutral"
      }, st.label)), /*#__PURE__*/React.createElement("td", {
        className: "dim"
      }, st.row && st.row.lastSync ? String(st.row.lastSync).slice(0, 10) : "·"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, this.renderAction(item, st, admin, selfService)))];
      if (open && item.kind === "content" && admin) rows.push(/*#__PURE__*/React.createElement("tr", {
        key: item.key + "-form"
      }, /*#__PURE__*/React.createElement("td", {
        colSpan: 4
      }, this.renderForm(item))));
      return rows;
    })])))));
  }
}